//include 9

/*
some description what this module is suppoised to do. This is for future reference so I will not do some stupid shit cause I forgot...
On the page there are multiple forms, that have the same input elements/filters. A User usually wants to browse the site and keep the values he already put in
(for example dates). This module keeps the filters in local storage and prepopulates them when the use opens a page. The filters are being kept for an hour or so.
Rules to consider:

* Values from local storage should only be used to prepopulate the filters. Never should they be used to make a request directly 
(Except for the Availabilitysearch, but that's another story)

* Prefer POST Values. If a POST value is set do not use the value from local storage

*/

jQuery(function(){
    var privateFunctions = {
        saveFilters(container) {

            var group = container.data("filters");
            group = group || null;

            container.find("[data-filter-input]").each(function () {
                var name = $(this).data("filter-name");
                if (!name)
                    name = $(this).attr("name");
                var value,
                setValue = false,
				formElementFunctions = $(this).data("form-element-functions");
                if (!!formElementFunctions) {
                    value = formElementFunctions.get();
                    setValue = true;
                }
                else {
                    if ($(this).is(":checkbox") || $(this).is(":radio")) {
                        if ($(this).is(":checked")) {
                            value = $(this).val();
                            setValue = true;
                        }
                    }
                    else {
                        value = $(this).val();
                        setValue = true;
                    }
                }
                if (setValue) {
                    window.pixelpoint.filterManager.set(name, value, group);
                }
            });
        },
        loadFilters(container) {

            var group = container.data("filters");
            group = group || null;

            var savedFilters = window.pixelpoint.filterManager.get(null,null,group);
            container.find("[data-filter-input]").each(function () {             

                var ignoreFilter = $(this).is("[data-ignore-filter]");
                if (!!ignoreFilter)
                    return true; //we ignore the filter. If for example we already set the value via POST...

                var name = $(this).data("filter-name");
                if (!name)
                    name = $(this).attr("name");
                var formElementFunctions = $(this).data("form-element-functions");
                if (!!savedFilters && !!savedFilters[name]) {
                    if (!!formElementFunctions)
                        formElementFunctions.set(savedFilters[name]);
                    else {
                        if ($(this).is(":checkbox") || $(this).is(":radio")) {
                            var value = savedFilters[name];
                            if ($(this).val() == value)
                                $(this).prop("checked", true);
                        }
                        else {
                            $(this).val(savedFilters[name]);
                            if ($(this).data('select2')) {
                                $(this).trigger("change");
                            }
                        }
                    }
                }
            });
        }
    };

    $("[data-filters]").each(function () {
        var $this = $(this);
        if (!$this.is("[data-supress-save]")) {
            $this.find("form").addBack("form").on("submit", function (e) {
                privateFunctions.saveFilters($this);
            });
        }
        if (!$this.is("[data-supress-load]"))
            privateFunctions.loadFilters($this);
    });

});